import { cn } from '@/lib/cn';
import type { Product } from '@/types/catalog';

import { Skeleton } from '../ui/misc';
import { ProductCard } from './ProductCard';

interface ProductGridProps {
  products: Product[];
  /** Cards above this index get lazy-loaded images. */
  priorityCount?: number;
  className?: string;
}

export function ProductGrid({ products, priorityCount = 4, className }: ProductGridProps) {
  return (
    <ul
      className={cn('grid grid-cols-2 gap-4 lg:grid-cols-4 lg:gap-5', className)}
      aria-label="Lista de produtos"
    >
      {products.map((product, index) => (
        <li key={product.id} className="flex">
          <ProductCard product={product} priority={index < priorityCount} className="w-full" />
        </li>
      ))}
    </ul>
  );
}

export function ProductGridSkeleton({ count = 8 }: { count?: number }) {
  return (
    <div
      className="grid grid-cols-2 gap-4 lg:grid-cols-4 lg:gap-5"
      aria-busy="true"
      aria-label="Carregando produtos"
    >
      {Array.from({ length: count }, (_, index) => (
        <div
          key={index}
          className="flex flex-col gap-3 rounded-3xl border-2 border-sand-300 bg-white p-4"
        >
          <Skeleton className="aspect-[4/3] w-full rounded-2xl" />
          <Skeleton className="h-3 w-1/3" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-2/3" />
          <Skeleton className="mt-2 h-8 w-1/2" />
          <Skeleton className="h-11 w-full rounded-xl" />
        </div>
      ))}
    </div>
  );
}
